import React from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import iconTwitter from '../../assets/icon-twiter.svg';
import iconFacebook from '../../assets/icon-facebook.svg';
import iconWhatsApp from '../../assets/icon-whatsapp.svg';
import { StyledShareModal } from './ShareModal.style';

const ShareModal = () => {
  return (
    <StyledShareModal>
      <div className="holder">
        <ul className="socialnetwork">
          <li>
            <button type="button">
              <div className="icon-box">
                <img src={iconTwitter} width="45" alt="twitter" />
              </div>
              <span className="text">X</span>
            </button>
          </li>
          <li>
            <button type="button">
              <div className="icon-box">
                <img src={iconFacebook} width="45" alt="facebook" />
              </div>
              <span className="text">Facebook</span>
            </button>
          </li>
          <li>
            <button type="button">
              <div className="icon-box">
                <img src={iconWhatsApp} width="45" alt="whatsapp" />
              </div>
              <span className="text">WhatsApp</span>
            </button>
          </li>
        </ul>
        <div className="input-box">
          <input type="text" placeholder="https://" />
          <span className="btn-copy">
            <IoCopyOutline />
          </span>
        </div>
      </div>
    </StyledShareModal>
  );
};

export default ShareModal;
